import axios from 'axios';

export const DocumentService = {
  /**
   * Envoie un document signé par email via le backend.
   * @param blob Le Blob du PDF signé.
   * @param recipientEmail L'email du destinataire.
   * @param projectTitle Le titre du projet pour le contexte de l'email.
   * @param originalFileName Le nom du fichier original.
   */
  async sendSignedDocument(
    blob: Blob, 
    recipientEmail: string, 
    projectTitle: string,
    originalFileName: string
  ): Promise<void> {
    try {
      const formData = new FormData();
      
      // Ajoute le fichier PDF signé
      formData.append('signedDocument', blob, `signed-${originalFileName}`);
      
      // Ajoute les métadonnées
      formData.append('to', recipientEmail);
      formData.append('projectTitle', projectTitle);
      formData.append('originalFileName', originalFileName);

      // Envoie la requête au backend
      await axios.post('https://flexihub.io/api/documents/send-signed', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Document signé envoyé avec succès par email.');

    } catch (error) {
      console.error("Erreur lors de l'envoi du document signé par email:", error);
      // On ne bloque pas l'utilisateur, le téléchargement fonctionnera toujours.
      // On pourrait afficher une notification d'erreur ici.
      throw new Error("L'envoi par email a échoué, mais le document a été téléchargé.");
    }
  }
};